import Vue from 'vue'
import popStorage from '@/constants/LocalStorageManagement' 

const vm = new Vue()

export const fetchCouponBalanceToLocalStorage = async () => {
    const apiPath = '/coupon/balance'

    return new Promise((resolve, reject) => {
        vm.$http.get(vm.$API_URL + apiPath, {
            headers: {
                Token: localStorage.getItem('access_token')
            }
        }).then((res) => {
            if (res.data && res.data.data) {
                popStorage.coupon().set({
                    status: res.data.data.status,
                    balance_amount: res.data.data.balance_amount,
                    total_amount: res.data.data.total_amount,
                    balance_value: res.data.data.balance_value,
                    total_value: res.data.data.total_value
                })

                resolve(res.data.data)
            } else {
                reject()
            }
        }).catch(err => reject(err))
    })
}

export const previewCoupon = async (currentParcel, prev) => {
    const apiPath = '/coupon/preview'

    return new Promise((resolve, reject) => {
        vm.$http.post(vm.$API_URL + apiPath, {
            data: {
                prev,
                current: currentParcel
            }
        }, {
            headers: {
                Token: localStorage.getItem('access_token')
            },
        }).then((res) => {
            if (res.data && res.data.data) {
                resolve(res.data.data)
            } else {
                reject()
            }
        }).catch(err => reject(err))
    })
}

export const fetchCoupons = async (filter) => {
    const apiPath = '/coupon'

    return new Promise((resolve, reject) => {
        vm.$http.get(vm.$API_URL + apiPath, {
            headers: {
                Token: localStorage.getItem('access_token')
            },
            params: filter
        }).then((res) => {
            if (res.data) {
                resolve(res.data.data)
            } else {
                reject()
            }
        }).catch(err => reject(err))
    })
}